import { Tooltip } from '../Tooltip/Tooltip'
import { CheckboxCellProps } from './types'

export const CheckboxCell = ({ tooltipText, children }: CheckboxCellProps) =>
  tooltipText ? (
    <Tooltip title={tooltipText}>{children}</Tooltip>
  ) : (
    <>{children}</>
  )
